{
  "comment": "recovery and clearRaiders markerDistance [min, max] (m) are from the issuing station's hull: the marker sits R + d from its centre, R the station's bounding radius, and at least encounters.json stationExclusion off every station's hull (scale SC-5e1).",
  "perStation": [3, 5],
  "unlockStanding": 25,
  "unlockMult": 1.5,
  "standingReward": [5, 10],
  "standingPenalty": 5,
  "factionStanding": { "holdfast": { "flat": 10, "until": 25 } },
  "reconciliation": { "faction": "holdfast", "atOrBelow": -50, "restoreTo": -40, "credits": 20000 },
  "story": {
    "contrabandFine": 3000,
    "waveThroughStanding": 50,
    "holdfastWatchLogs": [{ "nth": 1, "log": "watch.contract_docket" }, { "nth": 3, "log": "watch.contract_book_page" }],
    "candleRun": { "target": "harrow", "goods": [{ "good": "fuel_cells", "qty": 4 }, { "good": "electronics", "qty": 1 }] }
  },
  "types": {
    "delivery": { "weight": 3, "tons": [5, 20], "rewardMult": 1.4, "deadlineCycles": 2 },
    "recovery": { "weight": 2, "rewardBonus": 0.3, "deadlineCycles": 1, "markerDistance": [3000, 7000] },
    "clearRaiders": { "weight": 2, "reward": [6000, 15000], "deadlineCycles": 1, "markerDistance": [4000, 8000], "spawnWithin": 4000 },
    "courier": { "weight": 2, "reward": [4000, 8000], "deadlineSeconds": 1200, "podMassT": 2 },
    "laneRepair": { "weight": 1, "rewardMult": 1.6, "deadlineCycles": 2 },
    "relayParts": { "weight": 2, "units": [2, 6], "rewardMult": 1.5, "deadlineCycles": 2 },
    "chartSystem": { "weight": 1, "reward": [3000, 6000], "hopBonus": 0.5, "maxHops": 2, "deadlineCycles": 2 }
  }
}
